/* eslint-disable max-len */
import React from 'react';

export const Close = ({ ...props }) => (
    <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#close_svg__a)">
            <path d="M14.3 12.18a.242.242 0 0 1-.056-.27.24.24 0 0 1 .056-.08l9.26-9.27a1.49 1.49 0 0 0 0-2.12 1.51 1.51 0 0 0-2.12 0L12.18 9.7a.249.249 0 0 1-.36 0L2.56.44A1.51 1.51 0 0 0 .112.926 1.49 1.49 0 0 0 .44 2.56l9.26 9.27a.24.24 0 0 1 0 .35L.44 21.44a1.49 1.49 0 0 0 0 2.12 1.51 1.51 0 0 0 2.12 0l9.26-9.26a.25.25 0 0 1 .36 0l9.26 9.26a1.51 1.51 0 0 0 2.12 0 1.49 1.49 0 0 0 0-2.12l-9.26-9.26Z" />
        </g>
        <defs>
            <clipPath id="close_svg__a">
                <path d="M0 0h24v24H0z" />
            </clipPath>
        </defs>
    </svg>
);
